import { TunnelTriggerMode } from '../models/tunnel.model';

/** Validation limits from the tunnel admin API (contract §6). */
export const TUNNEL_NAME_MAX_LENGTH = 64;
export const TUNNEL_SERIAL_PATTERN = /^[A-Za-z0-9]{6,32}$/;
export const TUNNEL_RELAY_MIN = 1;
export const TUNNEL_RELAY_MAX = 255;
export const TUNNEL_PULSE_MS_MIN = 50;
export const TUNNEL_PULSE_MS_MAX = 10000;
export const TUNNEL_PULSE_MS_DEFAULT = 200;

export const TUNNEL_DEFAULT_TRIGGER_MODE: TunnelTriggerMode = 'order_sent';

export interface TunnelTriggerModeOption {
  value: TunnelTriggerMode;
  /** Short name for the tunnel card. */
  shortLabel: string;
  /** When the wash starts, worded for the person setting the tunnel up. */
  label: string;
}

export const TUNNEL_TRIGGER_MODE_OPTIONS: readonly TunnelTriggerModeOption[] = [
  {
    value: 'order_sent',
    shortLabel: 'Order sent to tunnel',
    label: 'When the order is sent to the tunnel (one lane, camera at the tunnel entrance)',
  },
  {
    value: 'entrance_read',
    shortLabel: 'Tunnel entrance camera read',
    label: 'When the tunnel entrance camera reads the plate (several lanes)',
  },
];
